import { px } from 'csx';
import React from 'react';
import { classes, style } from 'typestyle';
import { rebrand } from '../../../theme/color';
import { spacing } from '../../../theme/spacing';
import { mediaDesktop } from '../utilities/mediaQueries';
import { Container } from '../atoms/Container';

const styles = {
  wrapper: style(
    {
      padding: `${spacing.XLARGE} 0`,
      backgroundColor: rebrand.neutralOnDark[10].toString(),
    },
    mediaDesktop({
      paddingTop: spacing.XXXLARGE,
    })
  ),
  content: style({
    textAlign: 'center',
    maxWidth: px(540),
    margin: '0 auto',
  }),
};

interface LoginContentProps {
  className?: string;
}

export const LoginContent: React.FC<React.PropsWithChildren<LoginContentProps>> = ({ className, children }) => {
  return (
    <div className={classes(styles.wrapper, className)}>
      <Container>
        <div className={styles.content}>{children}</div>
      </Container>
    </div>
  );
};
